import { ReactNode } from 'react';

/**
 * Avoid showing widow/orphan text by splitting on the last word
 * https://fonts.google.com/knowledge/glossary/widows_orphans
 */
export const splitOnLastWord = (text: ReactNode) => {
  if (typeof text !== 'string') {
    return { mainText: '', lastWord: '' };
  }

  const words = text?.trim().split(' ');

  if (words.length === 1) {
    return { mainText: words[0], lastWord: '' };
  }

  const lastWord = words?.pop() ?? '';
  const mainText = words?.join(' ');
  return { mainText, lastWord };
};
